import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type TeamsState = {
  selectedId: string | null
  selectedBId: string | null
}

const initialState: TeamsState = {
  selectedId: null,
  selectedBId: null
}

export const teamsSlice = createSlice({
  name: 'teams',
  initialState,
  reducers: {
    setSelectedTeamId: (state, action: PayloadAction<string | null>) => {
      state.selectedId = action.payload
    },
    setSelectedBTeamId: (state, action: PayloadAction<string | null>) => {
      state.selectedBId = action.payload
    }
  }
})

export const reducer = teamsSlice.reducer

export const { setSelectedTeamId, setSelectedBTeamId } = teamsSlice.actions
